export const PubSubEvent = {
  MessageRestored: 'MessageRestored',
  MessageServiceReady: 'MessageServiceReady',
};
